export interface NavigationItem {
  to: string;
  label: string;
  area: string;
  description: string;
  icon: string;
  image?: string;
}

export interface NavigationGroup {
  label: string;
  items: NavigationItem[];
}

// A navegação descreve tarefas; as rotas das tabelas continuam estáveis.
export const NAVIGATION: NavigationGroup[] = [
  { label: "Dia a dia", items: [
    { to: "/feeds", label: "Feeds", area: "feeds", description: "O que mudou em cada fonte, com antes e depois", icon: "◷" },
    { to: "/", label: "Início", area: "inicio", description: "Atalhos para começar o trabalho", icon: "⌂" },
    { to: "/vincular", label: "Vincular carga", area: "vinculo", description: "Escolher motorista e placas por disponibilidade e distância", icon: "↔" },
    { to: "/painel", label: "Painel de carregamentos", area: "paineis", description: "Acompanhar quem e quando estará em carregamento", icon: "◉" },
    { to: "/torre", label: "Torre de Controle", area: "paineis", description: "Acompanhar cargas por empresa e situação", icon: "", image: "/icons/operacoes.png" },
    { to: "/programacao", label: "Programação", area: "programacao", description: "Consultar a programação e as importações", icon: "▤" },
    { to: "/cadastros", label: "Cadastros", area: "cadastros", description: "Veículos, motoristas, tarifas e regiões", icon: "▣" },
  ] },
  { label: "Resultados", items: [
    { to: "/indicadores", label: "Indicadores", area: "dashboard", description: "Dashboard de viagens e frete", icon: "↗" },
    { to: "/metas", label: "Metas", area: "metas", description: "Comparar objetivos por região", icon: "◎" },
    { to: "/insights", label: "Insights", area: "insights", description: "Analisar frete, desempenho e tendências", icon: "▥" },
    { to: "/explorar", label: "Explorar com IA", area: "explorar", description: "Montar análises e gráficos com IA", icon: "", image: "/icons/ajuda-ia.png" },
  ] },
  { label: "Tabelas e conferência", items: [
    { to: "/operacoes", label: "Operações", area: "operacoes", description: "Tabela completa de viagens e histórico de alterações", icon: "▦" },
    { to: "/dados", label: "Explorar dados", area: "dados", description: "Conferir tabelas das fontes, filtros e valores originais", icon: "▦" },
    { to: "/inconsistencias", label: "Inconsistências", area: "inconsistencias", description: "Investigar divergências e qualidade dos dados", icon: "!" },
  ] },
  { label: "Ajuda", items: [
    { to: "/agente", label: "Agente IA", area: "agente", description: "Tirar dúvidas sobre a operação", icon: "", image: "/icons/ajuda-ia.png" },
    { to: "/chamados", label: "Chamados", area: "chamados", description: "Acompanhar seus pedidos de suporte", icon: "", image: "/icons/suporte.png" },
    { to: "/atualizacoes", label: "Atualizações", area: "atualizacoes", description: "Ver o que mudou no portal", icon: "↻" },
  ] },
  { label: "Administração", items: [
    { to: "/admin", label: "Usuários e permissões", area: "admin", description: "Criar usuários, convites, grupos e permissões", icon: "⚙" },
    { to: "/entrega", label: "Acompanhamento", area: "entrega", description: "Acompanhar a entrega do projeto", icon: "✓" },
  ] },
];

const normalize = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function visibleNavigation(canArea: (area: string) => boolean, search = ""): NavigationGroup[] {
  const terms = normalize(search.trim()).split(/\s+/);
  return NAVIGATION.map((group) => ({
    ...group,
    items: group.items.filter((item) => canArea(item.area) && terms.every((term) =>
      normalize(`${group.label} ${item.label} ${item.description}`).includes(term))),
  })).filter((group) => group.items.length > 0);
}

export function currentNavigation(pathname: string) {
  for (const group of NAVIGATION) {
    const item = group.items.find((entry) => pathname === entry.to || (entry.to !== "/" && pathname.startsWith(`${entry.to}/`)));
    if (item) return { group: group.label, ...item };
  }
  return { group: "Sua conta", label: "Trocar senha", to: "/trocar-senha" };
}
